const config = {
    links: {
        home: 'https://estoques.net'
    },
    oauth: {
        domain: 'estoques.auth.us-west-2.amazoncognito.com',
        scope: ['email', 'profile', 'aws.cognito.signin.user.admin'],
        redirectSignIn: 'https://estoques.net/auth/login/social',
        redirectSignOut: 'https://estoques.net/auth/login',
        responseType: 'code',
    },
    cognito: {
        REGION: 'us-west-2',
        USER_POOL_ID: 'us-west-2_d5MzeKfXH',
        APP_CLIENT_ID: '1ivb452b9mntga6bb0jhnb1k21',
        IDENTITY_POOL_ID: 'us-west-2:f467f257-87b3-467c-b563-798dbf02af7a',
    },
    app: {
        domain: 'https://grid2b.com',
        cdn: 'https://images.grid2b.com',
    },
    api: {
        url: 'https://estoques.net/api/v1',
        // url: 'http://localhost:5000',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    endpoints: {
        search: 'https://a4ucq19b2a.execute-api.us-west-2.amazonaws.com/prod/grid2b/search',
        zipcode: 'https://cep.wdna.com.br/zipcode/search',
        pagseguro: 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.directpayment.js',
        websocket: 'wss://in3ddg2o41.execute-api.us-west-2.amazonaws.com/dev/',
    },
    catalog: {
        G2B: '1556051068835_5dd30c778d684ec08f19873b90fbbecb-grid2b',
    },
};

export default config;
